<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap ></b-overlay>
		<b-row>
			<b-col cols="3">
				<b-card>
					<h3>Zones <b-button @click="addZone" size="sm" variant="success"><md-icon icon="add"/></b-button></h3>
					<hr>
					<div
						class="mb-2"
						v-for="(zone,i) in zones"
						:key="i"
					>
						<b-input-group class="input-groups">
							<b-form-input v-if="editingZoneNameIndex == i" type="text"  v-model="zone.name" required />
							<b-button @click="selectZone(zone)" class="zone-button" v-else :variant="editingZone == zone ? 'warning' : 'primary' ">{{zone.name}}</b-button>
							<template #append>
								<b-button @click="editingZoneNameIndex == -1 ? editingZoneNameIndex = i : onUpdateZoneName()" variant="success">
									<md-icon v-if="editingZoneNameIndex != i" icon="edit" />
									<md-icon v-else icon="save" />
								</b-button>
								<b-button @click="deleteZone(i)" variant="danger"><md-icon icon="delete" /></b-button>
							</template>
						</b-input-group>
					</div>
				</b-card>
			</b-col>
			<b-col cols="7">
				<b-card>
					<h2 class="text-center">
						<template v-if="editingZone">
							Editing postal codes for zone: <strong>{{editingZone.name}}</strong><br>
						</template>
						<template v-else>
							Select or add a zone
						</template>
					</h2>
					<b-container>
						<b-form v-if="editingZone" @submit.prevent="addPostalCode" >
							<b-form-group label="Add postal code">
								<b-input-group size="sm" style="width: 200px">
									<b-form-input type="text" size="sm" v-model="newPostalCode" required />
									<b-input-group-append>
										<b-button type="submit" variant="success"><md-icon icon="add" /></b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-form>
						<hr>
						<div class="postal-code-container">
							<template v-if="editingZone">
								<b-input-group
									class="postal-code-input"
									v-for="(postalCode,index) in editingZone.postalCodes"
									:key="index"
								>
									<b-input-group size="sm" >
										<b-form-input type="text" size="sm" v-model="editingZone.postalCodes[index]" required disabled/>
										<b-input-group-append>
											<b-button @click="removePostalCode(index)" variant="danger"><md-icon icon="delete" /></b-button>
										</b-input-group-append>
									</b-input-group>
								</b-input-group>
							</template>
						</div>
					</b-container>
				</b-card>
			</b-col>
			<b-col cols="2">
				<b-card>
					<b-button @click="onSave" variant="success" size="lg" block><md-icon icon="save"/><br/>Save</b-button>
					<hr>
					<b-button @click="$emit('reFetch')" variant="warning" size="lg" block><md-icon icon="restore"/><br/>Restore</b-button>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>

export default {
		props: {
			zonedArea: {
				type : Object,
				required: true,
			},
		},
		components: { },
		data(){
			return {
				newPostalCode:'',
				zones : [],
				loading:true,
				editingZone:null,
				editingZoneHash:'',
				editingZoneNameIndex:-1,
			}
		},
		computed : {
		},
		methods:{
			removePostalCode(index){
				this.editingZone.postalCodes.splice(index, 1);
			},
			addPostalCode(){
				if(this.editingZone.postalCodes.find(ps => ps == this.newPostalCode)){
					this.$root.showAlert(`El codigo postal ${this.newPostalCode} ya se encuentra agregado a la zona ${this.editingZone.name}`,{variant:'danger'})
					return
				}
				this.editingZone.postalCodes.push(this.newPostalCode)
				this.newPostalCode = ''
			},
			onUpdateZoneName(){
				if(this.editingZone == this.zones[this.editingZoneNameIndex]){
					this.editingZoneHash = this.editingZone.name;
				}
				this.editingZoneNameIndex = -1
			},
			addZone(){
				this.zones.push({
					id:-1,
					name:`ZONE ${this.zones.length+1}`,
					postalCodes:[],
				})
				this.selectZone(this.zones[this.zones.length-1])
			},
			deleteZone(index){
				if (this.zones[index].id == -1) {
					this.zones.splice(index, 1);
				}else{
					this.$root.showWarning({
						message: "Si eliminas una zona, se eliminaran todos los costos relacionados a dicha zona al momento de guardar los cambios",
						okAction: (event, setLoading, close) => {
							// elimina zona no guardada
							setLoading(true);
							this.$root.api
								.delete(`/zones/${this.zones[index].id}`)
								.then(() => {
									this.$root.showAlert("Zona eliminada!", {
										variant: "warning"
									});

									this.zones.splice(index, 1);
									close();
								})
								.catch(err => {
									this.$root.handleRequestError(err);
									close();
								});
						}
					})
				}
			},
			selectZone(zone){
				this.editingZone = zone
				this.editingZoneHash = this.editingZone.name
			},
			initZones(zones){
				this.zones = zones.map(zone => {
					let auxZone = {
						id: zone.id,
						name: zone.name,
						postalCodes: zone.zonePostalCodes.map(pc => pc.postalCode),
					}
					return auxZone
				})
			},
			loadZonedArea(){
				this.loading = false
				this.initZones(this.zonedArea.zones)
				if (this.editingZoneHash) {
					let aux = this.zones.find(zone => this.editingZoneHash == zone.name)
					if(aux) this.editingZone = aux
				}
			},
			onSave(){
				let query = {
					zones : this.zones.map(zone => {
						return {
							id:zone.id,
							name:zone.name,
							postalCodes:zone.postalCodes,
						}
					})
				}
				this.$root.api.put(`/zoned-areas/${this.$root.getParams().id}/zones`,query).then( () => {
					this.$root.showAlert('Actualización exitosa')
					this.$emit('reFetch')
				}).catch(this.$root.handleRequestError);
			},
		},
		mounted(){
			this.loadZonedArea()
		},
		watch:{
			zonedArea: function(){
				this.editingZone = null
				this.loadZonedArea()
			}
		}
}
</script>

<style scoped>
	h2{
		min-height: 40px;
	}
	.postal-code-container{
		flex-direction: column;
		flex-wrap: wrap;
		display: flex;
		height: 500px;
		align-content: flex-start;
		overflow-y: auto;
	}
	.postal-code-input{
		width: 150px;
		margin: 10px 10px 0 0;
	}
	#search-box {
		width: 100%;
		max-width: 400px;
		padding: 5px;
		font-size: 16px;
	}
	.zone-button {
		flex: 1;
	}
	.input-groups {
		width: 100%;
	}
</style>
<style >
	#zones-map{
		width: 100%;
		height: 500px;
	}
</style>
